<template>  
  <div class="container-fluid mt-3">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <a class="navbar-brand" href="#">BuKanBan</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <button type="button" class="btn btn-outline-danger my-2 my-sm-0" @click="logout">Logout</button>
        </form>
      </div>
    </nav>
    <div class="row d-flex justify-content-start mt-3">

      <div class="col-md-3" id="backlog">
        <div class="card mb-3" style="background-color: rgba(150, 0, 0, 0.425);" >
          <div class="card-header">Backlog</div>
          <div class="card-body">
            <div class="box" v-for="task in listBacklog" :key="task.id">
              <div class="box-content">
                <p class="mb-5">{{ task.title }}</p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; right: 6%;"><a @click="updateTask(task.id)"><img src="https://img.icons8.com/material-sharp/24/000000/edit.png"></a></p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; left: 6%;"><a @click="deleteTask(task.id)" data-toggle="modal" data-target="#exampleModal"><img src="https://img.icons8.com/color/24/000000/delete-forever.png"></a></p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class=" col-lg-12">
                <input type="text" class="form-control" placeholder="Enter Task" v-model="newBacklog">
              </div>
              <div class="mt-3 col-lg-12">
                <button type="button" class="btn border-primary btn-block" @click="addTask('Backlog')">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3" id="product">
        <div class="card mb-3" style="background-color: rgba(241, 218, 8, 0.397);" >
          <div class="card-header ">Product</div>
          <div class="card-body">
            <div class="box" v-for="task in listProduct" :key="task.id">
              <div class="box-content">
                <p class="mb-5">{{ task.title }}</p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; right: 6%;"><a @click="updateTask(task.id)"><img src="https://img.icons8.com/material-sharp/24/000000/edit.png"></a></p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; left: 6%;"><a @click="deleteTask(task.id)" data-toggle="modal" data-target="#exampleModal"><img src="https://img.icons8.com/color/24/000000/delete-forever.png"></a></p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class=" col-lg-12">
              <input type="text" class="form-control" placeholder="Enter Task" v-model="newProduct">
              </div>
              <div class="mt-3 col-lg-12">
              <button type="button" class="btn  border-primary btn-block" @click="addTask('Product')">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3" id="development">
        <div class="card mb-3" style="background-color: rgba(0, 174, 255, 0.137);" >
          <div class="card-header">Development</div>
          <div class="card-body">
            <div class="box" v-for="task in listDevelopment" :key="task.id">
              <div class="box-content">
                <p class="mb-5">{{ task.title }}</p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; right: 6%;"><a @click="updateTask(task.id)"><img src="https://img.icons8.com/material-sharp/24/000000/edit.png"></a></p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; left: 6%;"><a @click="deleteTask(task.id)" data-toggle="modal" data-target="#exampleModal"><img src="https://img.icons8.com/color/24/000000/delete-forever.png"></a></p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class=" col-lg-12">
              <input type="text" class="form-control" placeholder="Enter Task" v-model="newDevelopment">
              </div>
              <div class="mt-3 col-lg-12">
              <button type="button" class="btn  border-primary btn-block" @click="addTask('Development')">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-3" id="done">
        <div class="card mb-3" style="background-color: rgba(4, 228, 23, 0.137);" >
          <div class="card-header">Done</div>
          <div class="card-body">
            <div class="box" v-for="task in listDone" :key="task.id">
              <div class="box-content">
                <p class="mb-5">{{ task.title }}</p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; right: 6%;"><a @click="updateTask(task.id)"><img src="https://img.icons8.com/material-sharp/24/000000/edit.png"></a></p>
                <p class="btn btn-sm text-right" style="position:absolute; bottom:0; left: 6%;"><a @click="deleteTask(task.id)" data-toggle="modal" data-target="#exampleModal"><img src="https://img.icons8.com/color/24/000000/delete-forever.png"></a></p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class=" col-lg-12">
              <input type="text" class="form-control" placeholder="Enter Task" v-model="newDone">
              </div>
              <div class="mt-3 col-lg-12">
              <button type="button" class="btn  border-primary btn-block" @click="addTask('Done')">Add</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  props: ['page'],
  data() {
    return {
      tasks: '',
      newBacklog: null,
      newProduct: null,
      newDevelopment: null,
      newDone: null,
      listBacklog:[],
      listDevelopment:[],
      listProduct:[],
      listDone:[],
      url: 'https://protected-taiga-35743.herokuapp.com',
    }
  },
  methods: {
    logout: function(){
      
      this.resetBoard()
      localStorage.removeItem('usertoken')
      this.$emit('changePage', {page: 'login'})
    },
    getTask: function(){
      let option = {
        method: 'get',
        headers: {'usertoken': localStorage.getItem('usertoken')},
        url: this.url+'/tasks',
      }
      axios(option)
      .then(data => {
        this.tasks = data.data
        this.filterData()
      })
      .catch(err => {
      })
    },
    addTask: function(ctgry){
      let newData = {}
      if(ctgry === 'Product'){
        newData.title = this.newProduct
        newData.category = 'Product'
      }else if(ctgry === 'Development'){
        newData.title = this.newDevelopment
        newData.category = 'Development'
      }else if(ctgry === 'Done'){
        newData.title = this.newDone
        newData.category = 'Done'
      }else{
        newData.title = this.newBacklog
        newData.category = 'Backlog'
      }
      let option = {
        method: 'post',
        headers: {'usertoken': localStorage.getItem('usertoken')},
        data: newData,
        url: this.url+'/tasks',
      }
      axios(option)
      .then(element => {
        this.resetBoard()
        this.getTask()
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Title Can\'t be empty',
          text: 'please fill the form',
          position: 'top',
        })
      })
    },
    deleteTask(id){
      const swalWithBootstrapButtons = Swal.mixin({
        position: 'top',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger mr-5'
        },
        buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          let option = {
            method: 'delete',
            headers: {'usertoken': localStorage.getItem('usertoken')},
            url: this.url+'/tasks/'+id,
          }
          axios(option)
          .then(element => {
            this.resetBoard()
            this.getTask()
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: 'Error Page',
              text: 'You need to refresh the page',
              position: 'top',
            })
          })
          swalWithBootstrapButtons.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          )
        } else if (
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          )
        }
      })
    },
    updateTask(id){
      Swal.mixin({
        input: 'text',
        confirmButtonText: 'Next &rarr;',
        showCancelButton: true,
        progressSteps: ['1', '2']
      }).queue([
        {
          title: 'Task Title',
          text: 'new task title'
        },
        {
          title: 'Category',
          input: 'select',
          inputOptions: {
            Backlog: 'Backlog',
            Product: 'Product',
            Development: 'Development',
            Done: 'Done'
          },
          inputPlaceholder: 'Select Category',
          showCancelButton: true,
        },
        
      ]).then((result) => {
        if (result.value) {
          const answers = JSON.stringify(result.value)
          let arr = JSON.parse(answers)
          let newData = {
            title: arr[0],
            category: arr[1]
          }
          if (newData) {
            let option = {
              method: 'put',
              headers: {'usertoken': localStorage.getItem('usertoken')},
              data: newData,
              url: this.url+'/tasks/'+id,
            }
            axios(option)
            .then(element => {
              this.resetBoard()
              this.getTask()
            })
            .catch(err => {
              Swal.fire({
                icon: 'error',
                title: 'Title or Category Can\'t be empty',
                text: 'please fill the form',
                position: 'top',
              })
            })
          }
          Swal.fire({
            title: 'Data has been updated!',
            html: `
              Your Task Updated:
              <pre><code>"${newData.title}" "${newData.category}"</code></pre>
            `,
            confirmButtonText: 'Okay!'
          })
        }
      })
    },
    filterData: function(){
      this.tasks.forEach(element => {
        if(element.category === 'Backlog'){
          this.listBacklog.push(element)
        }else if(element.category === 'Development'){
          this.listDevelopment.push(element)
        }else if(element.category === 'Product'){
          this.listProduct.push(element)
        }else if(element.category === 'Done'){
          this.listDone.push(element)
        }
      });
    },

    resetBoard: function(){
      this.newBacklog = null,
      this.newProduct = null,
      this.newDevelopment = null,
      this.newDone = null,
      this.listBacklog =[],
      this.listDevelopment =[],
      this.listProduct =[],
      this.listDone =[]
    },
  },
  created: function(){
    this.getTask()
  },
}
</script>